// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Zq-z","outfitFeedbackSection":"_q-z"};